import { render, staticRenderFns } from "./SubSkeleton.vue?vue&type=template&id=6853cbdb&scoped=true&"
import script from "./SubSkeleton.vue?vue&type=script&lang=js&"
export * from "./SubSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./SubSkeleton.vue?vue&type=style&index=0&id=6853cbdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6853cbdb",
  null
  
)

export default component.exports